export class SearchReturn {
    key: string;
    value: any;
}